"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TenantQueryResultsViewModel = exports.PaginationFilterViewModel = exports.PaginationSortViewModel = void 0;
require("reflect-metadata");
var class_transformer_1 = require("class-transformer");
var enums_1 = require("../users/enums");
var enums_2 = require("./enums");
var TenantView_model_1 = require("./TenantView.model");
var PaginationSortViewModel = /** @class */ (function () {
    function PaginationSortViewModel() {
        this.direction = enums_1.PaginationSortEnum.ASC;
        this.property = enums_2.SortableAndSearchableTenantModelPropertiesEnum.NAME;
    }
    __decorate([
        (0, class_transformer_1.Expose)(),
        __metadata("design:type", String)
    ], PaginationSortViewModel.prototype, "direction", void 0);
    __decorate([
        (0, class_transformer_1.Expose)(),
        __metadata("design:type", String)
    ], PaginationSortViewModel.prototype, "property", void 0);
    return PaginationSortViewModel;
}());
exports.PaginationSortViewModel = PaginationSortViewModel;
var PaginationFilterViewModel = /** @class */ (function () {
    function PaginationFilterViewModel() {
        this.operator = enums_2.TdxSearchOperatorEnum.LIKE;
        this.property = enums_2.FilterTenantPropertiesEnum.ALL;
        this.value = '';
    }
    __decorate([
        (0, class_transformer_1.Expose)(),
        __metadata("design:type", String)
    ], PaginationFilterViewModel.prototype, "operator", void 0);
    __decorate([
        (0, class_transformer_1.Expose)(),
        __metadata("design:type", String)
    ], PaginationFilterViewModel.prototype, "property", void 0);
    __decorate([
        (0, class_transformer_1.Expose)(),
        __metadata("design:type", Object)
    ], PaginationFilterViewModel.prototype, "value", void 0);
    return PaginationFilterViewModel;
}());
exports.PaginationFilterViewModel = PaginationFilterViewModel;
var TenantQueryResultsViewModel = /** @class */ (function () {
    function TenantQueryResultsViewModel() {
        this.data = [];
        this.limit = 1;
        this.page = 1;
        this.total = 1;
        this.sort = [
            (0, class_transformer_1.plainToClass)(PaginationSortViewModel, {}),
        ];
        this.filter = null;
    }
    __decorate([
        (0, class_transformer_1.Expose)(),
        (0, class_transformer_1.Type)(function () { return TenantView_model_1.TenantViewModel; }),
        __metadata("design:type", Array)
    ], TenantQueryResultsViewModel.prototype, "data", void 0);
    __decorate([
        (0, class_transformer_1.Expose)(),
        __metadata("design:type", Number)
    ], TenantQueryResultsViewModel.prototype, "limit", void 0);
    __decorate([
        (0, class_transformer_1.Expose)(),
        __metadata("design:type", Number)
    ], TenantQueryResultsViewModel.prototype, "page", void 0);
    __decorate([
        (0, class_transformer_1.Expose)(),
        __metadata("design:type", Number)
    ], TenantQueryResultsViewModel.prototype, "total", void 0);
    __decorate([
        (0, class_transformer_1.Expose)(),
        (0, class_transformer_1.Type)(function () { return PaginationSortViewModel; }),
        __metadata("design:type", Array)
    ], TenantQueryResultsViewModel.prototype, "sort", void 0);
    __decorate([
        (0, class_transformer_1.Expose)(),
        (0, class_transformer_1.Type)(function () { return PaginationFilterViewModel; }),
        __metadata("design:type", Object)
    ], TenantQueryResultsViewModel.prototype, "filter", void 0);
    return TenantQueryResultsViewModel;
}());
exports.TenantQueryResultsViewModel = TenantQueryResultsViewModel;
